import { render, staticRenderFns } from "./customer-types-modal.vue?vue&type=template&id=4d5b5ec4&"
import script from "./customer-types-modal.ts?vue&type=script&lang=ts&"
export * from "./customer-types-modal.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports